
// // import { useEffect, useState } from "react";
// // import "./PalaceVendorPages.css";

// // const API =
// //   process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

// // const STATUSES = [
// //   "AVAILABLE",
// //   "OCCUPIED",
// //   "RESERVED",
// //   "MAINTENANCE",
// //   "OUT_OF_SERVICE",
// //   "BLOCKED",
// // ];

// // const HOUSEKEEPING = [
// //   "CLEAN",
// //   "DIRTY",
// //   "INSPECTED",
// //   "CLEANING_IN_PROGRESS",
// // ];

// // async function api(url, options = {}) {
// //   const token = localStorage.getItem("vendorToken");

// //   const response = await fetch(`${API}${url}`, {
// //     ...options,
// //     headers: {
// //       ...(options.body
// //         ? { "Content-Type": "application/json" }
// //         : {}),
// //       ...(token ? { Authorization: `Bearer ${token}` } : {}),
// //       ...options.headers,
// //     },
// //   });

// //   const result = await response.json();

// //   if (!response.ok || result.success === false) {
// //     throw new Error(result.message || "Request failed");
// //   }

// //   return result;
// // }

// // const getList = (result) =>
// //   Array.isArray(result) ? result : result?.data || [];

// // const getId = (value) =>
// //   typeof value === "string" ? value : value?._id || "";

// // const initialForm = {
// //   roomCategoryId: "",
// //   roomNumber: "",
// //   floor: "",
// //   wing: "",
// //   notes: "",
// // };

// // export default function PalaceRoomUnits() {
// //   const [palaces, setPalaces] = useState([]);
// //   const [categories, setCategories] = useState([]);
// //   const [rooms, setRooms] = useState([]);

// //   const [palaceId, setPalaceId] = useState("");
// //   const [categoryFilter, setCategoryFilter] = useState("");
// //   const [search, setSearch] = useState("");

// //   const [form, setForm] = useState(initialForm);
// //   const [editingId, setEditingId] = useState("");

// //   const [loading, setLoading] = useState(false);
// //   const [saving, setSaving] = useState(false);
// //   const [error, setError] = useState("");
// //   const [message, setMessage] = useState("");

// //   useEffect(() => {
// //     loadPalaces();
// //   }, []);

// //   useEffect(() => {
// //     if (palaceId) {
// //       loadCategories();
// //       loadRooms();
// //     } else {
// //       setCategories([]);
// //       setRooms([]);
// //     }
// //   }, [palaceId]);

// //   async function loadPalaces() {
// //     try {
// //       const result = await api("/api/palaces");
// //       const list = getList(result);

// //       setPalaces(list);

// //       if (list.length) {
// //         setPalaceId(getId(list[0]));
// //       }
// //     } catch (err) {
// //       setError(err.message);
// //     }
// //   }

// //   async function loadCategories() {
// //     try {
// //       const result = await api(
// //         `/api/palace-room-categories/palace/${palaceId}`
// //       );

// //       setCategories(getList(result));
// //     } catch (err) {
// //       setError(err.message);
// //     }
// //   }

// //   async function loadRooms() {
// //     setLoading(true);
// //     setError("");

// //     try {
// //       const result = await api(
// //         `/api/palace-room-units/palace/${palaceId}`
// //       );

// //       setRooms(getList(result));
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }

// //   function resetForm() {
// //     setEditingId("");
// //     setForm(initialForm);
// //   }

// //   async function saveRoom(event) {
// //     event.preventDefault();
// //     setError("");
// //     setMessage("");

// //     if (!palaceId) {
// //       setError("Pehle palace select karo.");
// //       return;
// //     }

// //     if (!form.roomCategoryId || !form.roomNumber.trim()) {
// //       setError("Room category aur room number required hain.");
// //       return;
// //     }

// //     setSaving(true);

// //     try {
// //       const payload = {
// //         ...form,
// //         palaceId,
// //         roomNumber: form.roomNumber.trim(),
// //       };

// //       const result = await api(
// //         editingId
// //           ? `/api/palace-room-units/${editingId}`
// //           : "/api/palace-room-units",
// //         {
// //           method: editingId ? "PUT" : "POST",
// //           body: JSON.stringify(payload),
// //         }
// //       );

// //       setMessage(result.message || "Room saved successfully.");
// //       resetForm();
// //       await loadRooms();
// //     } catch (err) {
// //       setError(err.message);
// //     } finally {
// //       setSaving(false);
// //     }
// //   }

// //   function editRoom(room) {
// //     setEditingId(room._id);

// //     setForm({
// //       roomCategoryId: getId(room.roomCategory),
// //       roomNumber: room.roomNumber || "",
// //       floor: room.floor || "",
// //       wing: room.wing || "",
// //       notes: room.notes || "",
// //     });

// //     window.scrollTo({ top: 0, behavior: "smooth" });
// //   }

// //   async function updateRoom(id, endpoint, payload) {
// //     setError("");
// //     setMessage("");

// //     try {
// //       const result = await api(
// //         `/api/palace-room-units/${id}/${endpoint}`,
// //         {
// //           method: "PATCH",
// //           body: JSON.stringify(payload),
// //         }
// //       );

// //       setRooms((old) =>
// //         old.map((room) =>
// //           room._id === id ? result.data : room
// //         )
// //       );

// //       setMessage(result.message || "Room updated.");
// //     } catch (err) {
// //       setError(err.message);
// //     }
// //   }

// //   async function deleteRoom(room) {
// //     if (
// //       !window.confirm(
// //         `Room ${room.roomNumber} delete karna hai?`
// //       )
// //     ) {
// //       return;
// //     }

// //     try {
// //       const result = await api(
// //         `/api/palace-room-units/${room._id}`,
// //         { method: "DELETE" }
// //       );

// //       setMessage(result.message || "Room deleted.");
// //       await loadRooms();
// //     } catch (err) {
// //       setError(err.message);
// //     }
// //   }

// //   const filteredRooms = rooms.filter((room) => {
// //     const categoryMatch =
// //       !categoryFilter ||
// //       getId(room.roomCategory) === categoryFilter;

// //     const text = [
// //       room.roomNumber,
// //       room.floor,
// //       room.wing,
// //       room.roomCategory?.name,
// //     ]
// //       .join(" ")
// //       .toLowerCase();

// //     return categoryMatch && text.includes(search.toLowerCase());
// //   });

// //   const available = rooms.filter(
// //     (room) => room.status === "AVAILABLE"
// //   ).length;

// //   const occupied = rooms.filter(
// //     (room) => room.status === "OCCUPIED"
// //   ).length;

// //   return (
// //     <div className="pvp-page">
// //       <div className="pvp-heading">
// //         <div>
// //           <span className="pvp-eyebrow">PALACE OPERATIONS</span>
// //           <h1>Room Units</h1>
// //           <p>Manage room numbers, room status and housekeeping.</p>
// //         </div>

// //         <button
// //           className="pvp-btn pvp-btn-light"
// //           onClick={loadRooms}
// //           disabled={!palaceId}
// //         >
// //           Refresh
// //         </button>
// //       </div>

// //       <div className="pvp-stats">
// //         <div><span>Total rooms</span><strong>{rooms.length}</strong></div>
// //         <div><span>Available</span><strong>{available}</strong></div>
// //         <div><span>Occupied</span><strong>{occupied}</strong></div>
// //         <div>
// //           <span>Categories</span>
// //           <strong>{categories.length}</strong>
// //         </div>
// //       </div>

// //       {error && <div className="pvp-alert pvp-error">{error}</div>}
// //       {message && <div className="pvp-alert pvp-success">{message}</div>}

// //       <section className="pvp-card">
// //         <div className="pvp-card-title">
// //           <div>
// //             <h2>{editingId ? "Edit Room" : "Add Room Unit"}</h2>
// //             <p>Assign a room number to a palace room category.</p>
// //           </div>
// //         </div>

// //         <form className="pvp-form-grid" onSubmit={saveRoom}>
// //           <label>
// //             Palace
// //             <select
// //               value={palaceId}
// //               onChange={(e) => {
// //                 setPalaceId(e.target.value);
// //                 resetForm();
// //               }}
// //               required
// //             >
// //               <option value="">Select palace</option>
// //               {palaces.map((palace) => (
// //                 <option key={palace._id} value={palace._id}>
// //                   {palace.propertyName || palace.name || "Palace"}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>

// //           <label>
// //             Room Category
// //             <select
// //               value={form.roomCategoryId}
// //               onChange={(e) =>
// //                 setForm({ ...form, roomCategoryId: e.target.value })
// //               }
// //               required
// //             >
// //               <option value="">Select category</option>
// //               {categories.map((category) => (
// //                 <option key={category._id} value={category._id}>
// //                   {category.name || category.roomType}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>

// //           <label>
// //             Room Number
// //             <input
// //               value={form.roomNumber}
// //               onChange={(e) =>
// //                 setForm({ ...form, roomNumber: e.target.value })
// //               }
// //               placeholder="101"
// //               required
// //             />
// //           </label>

// //           <label>
// //             Floor
// //             <input
// //               value={form.floor}
// //               onChange={(e) =>
// //                 setForm({ ...form, floor: e.target.value })
// //               }
// //               placeholder="Ground floor"
// //             />
// //           </label>

// //           <label>
// //             Wing / Block
// //             <input
// //               value={form.wing}
// //               onChange={(e) =>
// //                 setForm({ ...form, wing: e.target.value })
// //               }
// //               placeholder="A Wing"
// //             />
// //           </label>

// //           <label className="pvp-span-2">
// //             Notes
// //             <textarea
// //               rows="2"
// //               value={form.notes}
// //               onChange={(e) =>
// //                 setForm({ ...form, notes: e.target.value })
// //               }
// //               placeholder="Optional notes"
// //             />
// //           </label>

// //           <div className="pvp-form-actions pvp-span-2">
// //             {editingId && (
// //               <button
// //                 type="button"
// //                 className="pvp-btn pvp-btn-light"
// //                 onClick={resetForm}
// //               >
// //                 Cancel
// //               </button>
// //             )}

// //             <button className="pvp-btn pvp-btn-primary" disabled={saving}>
// //               {saving
// //                 ? "Saving..."
// //                 : editingId
// //                 ? "Update Room"
// //                 : "Create Room"}
// //             </button>
// //           </div>
// //         </form>
// //       </section>

// //       <section className="pvp-card">
// //         <div className="pvp-card-title">
// //           <div>
// //             <h2>Room Directory</h2>
// //             <p>Change status and housekeeping directly from the list.</p>
// //           </div>
// //         </div>

// //         <div className="pvp-toolbar">
// //           <input
// //             placeholder="Search room number, floor or wing..."
// //             value={search}
// //             onChange={(e) => setSearch(e.target.value)}
// //           />

// //           <select
// //             value={categoryFilter}
// //             onChange={(e) => setCategoryFilter(e.target.value)}
// //           >
// //             <option value="">All categories</option>
// //             {categories.map((category) => (
// //               <option key={category._id} value={category._id}>
// //                 {category.name || category.roomType}
// //               </option>
// //             ))}
// //           </select>
// //         </div>

// //         {loading ? (
// //           <div className="pvp-empty">Loading rooms...</div>
// //         ) : filteredRooms.length === 0 ? (
// //           <div className="pvp-empty">
// //             <strong>No rooms found</strong>
// //             <span>Add a room or change the filters.</span>
// //           </div>
// //         ) : (
// //           <div className="pvp-table-wrap">
// //             <table className="pvp-table">
// //               <thead>
// //                 <tr>
// //                   <th>Room</th>
// //                   <th>Category</th>
// //                   <th>Floor / Wing</th>
// //                   <th>Status</th>
// //                   <th>Housekeeping</th>
// //                   <th>Actions</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {filteredRooms.map((room) => (
// //                   <tr key={room._id}>
// //                     <td><strong>{room.roomNumber}</strong></td>
// //                     <td>
// //                       {room.roomCategory?.name ||
// //                         room.roomCategory?.roomType ||
// //                         "—"}
// //                     </td>
// //                     <td>
// //                       {[room.floor, room.wing].filter(Boolean).join(" / ") || "—"}
// //                     </td>

// //                     <td>
// //                       <select
// //                         className="pvp-table-select"
// //                         value={room.status || "AVAILABLE"}
// //                         onChange={(e) =>
// //                           updateRoom(room._id, "status", {
// //                             status: e.target.value,
// //                           })
// //                         }
// //                       >
// //                         {STATUSES.map((status) => (
// //                           <option key={status} value={status}>{status}</option>
// //                         ))}
// //                       </select>
// //                     </td>

// //                     <td>
// //                       <select
// //                         className="pvp-table-select"
// //                         value={room.housekeepingStatus || "CLEAN"}
// //                         onChange={(e) =>
// //                           updateRoom(room._id, "housekeeping", {
// //                             housekeepingStatus: e.target.value,
// //                           })
// //                         }
// //                       >
// //                         {HOUSEKEEPING.map((status) => (
// //                           <option key={status} value={status}>{status}</option>
// //                         ))}
// //                       </select>
// //                     </td>

// //                     <td>
// //                       <div className="pvp-row-actions">
// //                         <button onClick={() => editRoom(room)}>Edit</button>
// //                         <button
// //                           className="pvp-danger-text"
// //                           onClick={() => deleteRoom(room)}
// //                         >
// //                           Delete
// //                         </button>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         )}
// //       </section>
// //     </div>
// //   );
// // }

// import React, { useEffect, useState } from "react";

// const API = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

// const emptyForm = {
//   roomCategoryId: "",
//   roomNumber: "",
//   floor: "",
//   wing: "",
//   notes: "",
// };

// async function apiRequest(url, options = {}) {
//   const token = localStorage.getItem("vendorToken");

//   const response = await fetch(`${API}${url}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//       ...options.headers,
//     },
//   });

//   const result = await response.json();

//   if (!response.ok) {
//     throw new Error(result.message || "Something went wrong");
//   }

//   return result;
// }

// function getList(result, keys = []) {
//   if (Array.isArray(result)) return result;

//   for (const key of keys) {
//     if (Array.isArray(result?.[key])) return result[key];
//   }

//   if (Array.isArray(result?.data)) return result.data;

//   return [];
// }

// function getCategoryId(room) {
//   const value = room?.roomCategoryId || room?.roomCategory;
//   return typeof value === "object" ? value?._id || "" : value || "";
// }

// function getCategoryName(room, categories) {
//   const value = room?.roomCategoryId || room?.roomCategory;

//   if (value && typeof value === "object") {
//     return value.title || value.name || "—";
//   }

//   return (
//     categories.find((category) => category._id === value)?.title ||
//     categories.find((category) => category._id === value)?.name ||
//     "—"
//   );
// }

// function StatCard({ title, value, icon }) {
//   return (
//     <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
//       <div className="flex items-center justify-between">
//         <p className="text-sm font-medium text-slate-500">{title}</p>
//         <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-xl">
//           {icon}
//         </span>
//       </div>
//       <p className="mt-4 text-3xl font-bold text-slate-900">{value}</p>
//     </div>
//   );
// }

// function StatusBadge({ status }) {
//   const value = String(status || "available").toLowerCase();

//   const styles = {
//     available: "bg-emerald-50 text-emerald-700 ring-emerald-200",
//     occupied: "bg-blue-50 text-blue-700 ring-blue-200",
//     maintenance: "bg-amber-50 text-amber-700 ring-amber-200",
//     blocked: "bg-red-50 text-red-700 ring-red-200",
//     clean: "bg-emerald-50 text-emerald-700 ring-emerald-200",
//     dirty: "bg-red-50 text-red-700 ring-red-200",
//     cleaning: "bg-amber-50 text-amber-700 ring-amber-200",
//     inspected: "bg-indigo-50 text-indigo-700 ring-indigo-200",
//   };

//   return (
//     <span
//       className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold capitalize ring-1 ring-inset ${
//         styles[value] || "bg-slate-100 text-slate-600 ring-slate-200"
//       }`}
//     >
//       {value.replaceAll("_", " ")}
//     </span>
//   );
// }

// export default function PalaceRoomUnits() {
//   const [palaces, setPalaces] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [rooms, setRooms] = useState([]);

//   const [palaceId, setPalaceId] = useState("");
//   const [search, setSearch] = useState("");

//   const [loadingPalaces, setLoadingPalaces] = useState(true);
//   const [loadingRooms, setLoadingRooms] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [showForm, setShowForm] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [form, setForm] = useState(emptyForm);

//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   useEffect(() => {
//     loadPalaces();
//   }, []);

//   useEffect(() => {
//     if (palaceId) {
//       loadRooms(palaceId);
//     } else {
//       setRooms([]);
//       setCategories([]);
//     }
//   }, [palaceId]);

//   async function loadPalaces() {
//     setLoadingPalaces(true);
//     setError("");

//     try {
//       const result = await apiRequest("/api/palaces");
//       const list = getList(result, ["palaces"]);

//       setPalaces(list);

//       if (list.length > 0) {
//         setPalaceId((current) => current || list[0]._id);
//       }
//     } catch (err) {
//       setError(err.message || "Unable to load palaces");
//     } finally {
//       setLoadingPalaces(false);
//     }
//   }

//   async function loadRooms(id = palaceId) {
//     if (!id) return;

//     setLoadingRooms(true);
//     setError("");

//     try {
//       const [roomResult, categoryResult] = await Promise.all([
//         apiRequest(`/api/palace-room-units/palace/${id}`),
//         apiRequest(`/api/palace-room-categories/palace/${id}`),
//       ]);

//       setRooms(getList(roomResult, ["rooms"]));
//       setCategories(getList(categoryResult, ["categories"]));
//     } catch (err) {
//       setError(err.message || "Unable to load room data");
//     } finally {
//       setLoadingRooms(false);
//     }
//   }

//   function resetForm() {
//     setForm(emptyForm);
//     setEditingId(null);
//     setShowForm(false);
//   }

//   function openAddForm() {
//     setForm(emptyForm);
//     setEditingId(null);
//     setError("");
//     setSuccess("");
//     setShowForm(true);
//   }

//   function handleFieldChange(event) {
//     const { name, value } = event.target;

//     setForm((current) => ({
//       ...current,
//       [name]: value,
//     }));
//   }

//   async function handleSubmit(event) {
//     event.preventDefault();

//     if (!palaceId) {
//       setError("Please select a palace first.");
//       return;
//     }

//     if (!form.roomCategoryId || !form.roomNumber.trim()) {
//       setError("Room Category and Room Number are required.");
//       return;
//     }

//     setSaving(true);
//     setError("");
//     setSuccess("");

//     const payload = {
//       palaceId,
//       roomCategoryId: form.roomCategoryId,
//       roomNumber: form.roomNumber.trim(),
//       floor: form.floor === "" ? "" : Number(form.floor),
//       wing: form.wing.trim(),
//       notes: form.notes.trim(),
//     };

//     try {
//       const url = editingId
//         ? `/api/palace-room-units/${editingId}`
//         : "/api/palace-room-units";

//       await apiRequest(url, {
//         method: editingId ? "PUT" : "POST",
//         body: JSON.stringify(payload),
//       });

//       setSuccess(editingId ? "Room updated successfully." : "Room added successfully.");

//       resetForm();
//       await loadRooms(palaceId);
//     } catch (err) {
//       setError(err.message || "Unable to save room");
//     } finally {
//       setSaving(false);
//     }
//   }

//   function handleEdit(room) {
//     setForm({
//       roomCategoryId: getCategoryId(room),
//       roomNumber: room.roomNumber || "",
//       floor: room.floor ?? "",
//       wing: room.wing || "",
//       notes: room.notes || "",
//     });

//     setEditingId(room._id);
//     setShowForm(true);
//     setError("");
//     setSuccess("");

//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }

//   async function handleDelete(room) {
//     const confirmed = window.confirm(
//       `Are you sure you want to delete room ${room.roomNumber}?`
//     );

//     if (!confirmed) return;

//     setError("");
//     setSuccess("");

//     try {
//       await apiRequest(`/api/palace-room-units/${room._id}`, {
//         method: "DELETE",
//       });

//       setSuccess("Room deleted successfully.");
//       await loadRooms(palaceId);
//     } catch (err) {
//       setError(err.message || "Unable to delete room");
//     }
//   }

//   async function handleStatusChange(room, status) {
//     setError("");
//     setSuccess("");

//     try {
//       await apiRequest(`/api/palace-room-units/${room._id}/status`, {
//         method: "PATCH",
//         body: JSON.stringify({ status }),
//       });

//       await loadRooms(palaceId);
//       setSuccess("Room status updated.");
//     } catch (err) {
//       setError(err.message || "Unable to update room status");
//     }
//   }

//   async function handleHousekeepingChange(room, housekeepingStatus) {
//     setError("");
//     setSuccess("");

//     try {
//       await apiRequest(`/api/palace-room-units/${room._id}/housekeeping`, {
//         method: "PATCH",
//         body: JSON.stringify({ housekeepingStatus }),
//       });

//       await loadRooms(palaceId);
//       setSuccess("Housekeeping status updated.");
//     } catch (err) {
//       setError(err.message || "Unable to update housekeeping status");
//     }
//   }

//   const filteredRooms = rooms.filter((room) => {
//     const query = search.trim().toLowerCase();
//     if (!query) return true;

//     const categoryName = getCategoryName(room, categories);

//     return [
//       room.roomNumber,
//       room.floor,
//       room.wing,
//       categoryName,
//       room.status,
//       room.housekeepingStatus,
//     ]
//       .join(" ")
//       .toLowerCase()
//       .includes(query);
//   });

//   const availableCount = rooms.filter(
//     (room) => String(room.status || "available").toLowerCase() === "available"
//   ).length;

//   const occupiedCount = rooms.filter(
//     (room) => String(room.status).toLowerCase() === "occupied"
//   ).length;

//   const maintenanceCount = rooms.filter(
//     (room) => String(room.status).toLowerCase() === "maintenance"
//   ).length;

//   return (
//     <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">
//       <div className="mx-auto max-w-[1500px] space-y-6">
//         {/* Page heading */}
//         <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
//           <div>
//             <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 sm:text-sm">
//               Property Management
//             </p>
//             <h1 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
//               Palace Room Units
//             </h1>
//             <p className="mt-2 text-sm text-slate-500 sm:text-base">
//               Manage room numbers, room status and housekeeping.
//             </p>
//           </div>

//           {!showForm && (
//             <button
//               type="button"
//               onClick={openAddForm}
//               disabled={!palaceId}
//               className="inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-5 py-3 font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-200 disabled:cursor-not-allowed disabled:opacity-50"
//             >
//               <span className="text-xl leading-none">+</span>
//               Add Room
//             </button>
//           )}
//         </div>

//         {/* Alerts */}
//         {error && (
//           <div
//             role="alert"
//             className="flex items-start justify-between gap-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
//           >
//             <span>{error}</span>
//             <button
//               type="button"
//               onClick={() => setError("")}
//               className="font-bold"
//               aria-label="Dismiss error"
//             >
//               ✕
//             </button>
//           </div>
//         )}

//         {success && (
//           <div
//             role="status"
//             className="flex items-start justify-between gap-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700"
//           >
//             <span>{success}</span>
//             <button
//               type="button"
//               onClick={() => setSuccess("")}
//               className="font-bold"
//               aria-label="Dismiss success"
//             >
//               ✕
//             </button>
//           </div>
//         )}

//         {/* Palace selector */}
//         <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
//           <label
//             htmlFor="palace-select"
//             className="mb-2 block text-sm font-semibold text-slate-800"
//           >
//             Select Palace
//           </label>

//           <select
//             id="palace-select"
//             value={palaceId}
//             onChange={(event) => {
//               setPalaceId(event.target.value);
//               resetForm();
//               setError("");
//               setSuccess("");
//             }}
//             disabled={loadingPalaces}
//             className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 sm:max-w-lg"
//           >
//             <option value="">
//               {loadingPalaces ? "Loading palaces..." : "Select a palace"}
//             </option>

//             {palaces.map((palace) => (
//               <option key={palace._id} value={palace._id}>
//                 {palace.name || palace.title || "Unnamed Palace"}
//               </option>
//             ))}
//           </select>

//           {!loadingPalaces && palaces.length === 0 && (
//             <p className="mt-3 text-sm text-amber-700">
//               No palaces found. Check the palace API response and vendor login.
//             </p>
//           )}
//         </section>

//         {/* Summary cards */}
//         <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
//           <StatCard title="Total Rooms" value={rooms.length} icon="🏨" />
//           <StatCard title="Available" value={availableCount} icon="✓" />
//           <StatCard title="Occupied" value={occupiedCount} icon="🛏️" />
//           <StatCard title="Maintenance" value={maintenanceCount} icon="🔧" />
//         </section>

//         {/* Add / Edit form: hidden until button click */}
//         {showForm && (
//           <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
//             <div className="flex flex-col justify-between gap-3 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:px-7">
//               <div>
//                 <h2 className="text-xl font-bold text-slate-900">
//                   {editingId ? "Edit Room" : "Add New Room"}
//                 </h2>
//                 <p className="mt-1 text-sm text-slate-500">
//                   Enter the room details below.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="self-start rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 sm:self-auto"
//               >
//                 Close Form ✕
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} className="p-5 sm:p-7">
//               {/* Keep the original field order */}
//               <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
//                 <div>
//                   <label
//                     htmlFor="roomCategoryId"
//                     className="mb-2 block text-sm font-semibold text-slate-700"
//                   >
//                     Room Category <span className="text-red-500">*</span>
//                   </label>

//                   <select
//                     id="roomCategoryId"
//                     name="roomCategoryId"
//                     value={form.roomCategoryId}
//                     onChange={handleFieldChange}
//                     required
//                     className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//                   >
//                     <option value="">Select room category</option>
//                     {categories.map((category) => (
//                       <option key={category._id} value={category._id}>
//                         {category.title || category.name || "Unnamed Category"}
//                       </option>
//                     ))}
//                   </select>

//                   {categories.length === 0 && (
//                     <p className="mt-2 text-xs text-amber-700">
//                       No categories found for this palace.
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label
//                     htmlFor="roomNumber"
//                     className="mb-2 block text-sm font-semibold text-slate-700"
//                   >
//                     Room Number <span className="text-red-500">*</span>
//                   </label>

//                   <input
//                     id="roomNumber"
//                     name="roomNumber"
//                     value={form.roomNumber}
//                     onChange={handleFieldChange}
//                     required
//                     placeholder="e.g. 101"
//                     className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//                   />
//                 </div>

//                 <div>
//                   <label
//                     htmlFor="floor"
//                     className="mb-2 block text-sm font-semibold text-slate-700"
//                   >
//                     Floor
//                   </label>

//                   <input
//                     id="floor"
//                     name="floor"
//                     type="number"
//                     value={form.floor}
//                     onChange={handleFieldChange}
//                     placeholder="e.g. 1"
//                     className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//                   />
//                 </div>

//                 <div>
//                   <label
//                     htmlFor="wing"
//                     className="mb-2 block text-sm font-semibold text-slate-700"
//                   >
//                     Wing
//                   </label>

//                   <input
//                     id="wing"
//                     name="wing"
//                     value={form.wing}
//                     onChange={handleFieldChange}
//                     placeholder="e.g. East Wing"
//                     className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//                   />
//                 </div>

//                 <div className="md:col-span-2">
//                   <label
//                     htmlFor="notes"
//                     className="mb-2 block text-sm font-semibold text-slate-700"
//                   >
//                     Notes
//                   </label>

//                   <textarea
//                     id="notes"
//                     name="notes"
//                     value={form.notes}
//                     onChange={handleFieldChange}
//                     rows={3}
//                     placeholder="Add optional room notes..."
//                     className="w-full resize-y rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//                   />
//                 </div>
//               </div>

//               <div className="mt-7 flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">
//                 <button
//                   type="button"
//                   onClick={resetForm}
//                   className="rounded-xl border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="submit"
//                   disabled={saving || categories.length === 0}
//                   className="rounded-xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-200 disabled:cursor-not-allowed disabled:opacity-50"
//                 >
//                   {saving
//                     ? "Saving..."
//                     : editingId
//                     ? "Update Room"
//                     : "Save Room"}
//                 </button>
//               </div>
//             </form>
//           </section>
//         )}

//         {/* Rooms table */}
//         <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
//           <div className="flex flex-col justify-between gap-4 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:p-6">
//             <div>
//               <h2 className="text-lg font-bold text-slate-900">All Rooms</h2>
//               <p className="mt-1 text-sm text-slate-500">
//                 {filteredRooms.length} room{filteredRooms.length !== 1 ? "s" : ""} found
//               </p>
//             </div>

//             <div className="relative w-full sm:max-w-sm">
//               <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
//                 ⌕
//               </span>
//               <input
//                 type="search"
//                 value={search}
//                 onChange={(event) => setSearch(event.target.value)}
//                 placeholder="Search rooms..."
//                 className="w-full rounded-xl border border-slate-200 py-3 pl-9 pr-4 text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
//               />
//             </div>
//           </div>

//           {!palaceId ? (
//             <div className="p-10 text-center text-sm text-slate-500">
//               Select a palace to view its rooms.
//             </div>
//           ) : loadingRooms ? (
//             <div className="p-12 text-center">
//               <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-indigo-100 border-t-indigo-600" />
//               <p className="mt-3 text-sm text-slate-500">Loading rooms...</p>
//             </div>
//           ) : filteredRooms.length === 0 ? (
//             <div className="px-5 py-14 text-center">
//               <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-2xl">
//                 🏨
//               </div>
//               <h3 className="mt-4 font-bold text-slate-900">No rooms found</h3>
//               <p className="mt-1 text-sm text-slate-500">
//                 {search
//                   ? "Try another search term."
//                   : "Add your first room using the Add Room button."}
//               </p>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="w-full min-w-[1050px] text-left text-sm">
//                 <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
//                   <tr>
//                     <th className="px-5 py-4 font-semibold">Room Number</th>
//                     <th className="px-5 py-4 font-semibold">Category</th>
//                     <th className="px-5 py-4 font-semibold">Floor / Wing</th>
//                     <th className="px-5 py-4 font-semibold">Room Status</th>
//                     <th className="px-5 py-4 font-semibold">Housekeeping</th>
//                     <th className="px-5 py-4 text-right font-semibold">Actions</th>
//                   </tr>
//                 </thead>

//                 <tbody className="divide-y divide-slate-100">
//                   {filteredRooms.map((room) => (
//                     <tr
//                       key={room._id}
//                       className="transition hover:bg-slate-50/80"
//                     >
//                       <td className="px-5 py-4">
//                         <span className="font-bold text-slate-900">
//                           {room.roomNumber || "—"}
//                         </span>
//                       </td>

//                       <td className="px-5 py-4 text-slate-600">
//                         {getCategoryName(room, categories)}
//                       </td>

//                       <td className="px-5 py-4 text-slate-600">
//                         <span>{room.floor ?? "—"}</span>
//                         <span className="mx-2 text-slate-300">/</span>
//                         <span>{room.wing || "—"}</span>
//                       </td>

//                       <td className="px-5 py-4">
//                         <div className="flex flex-col items-start gap-2">
//                           <StatusBadge status={room.status} />
//                           <select
//                             aria-label={`Change room status for ${room.roomNumber}`}
//                             value={room.status || "available"}
//                             onChange={(event) =>
//                               handleStatusChange(room, event.target.value)
//                             }
//                             className="max-w-40 rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs outline-none focus:border-indigo-500"
//                           >
//                             {[
//                               "available",
//                               "occupied",
//                               "maintenance",
//                               "blocked",
//                             ].map((status) => (
//                               <option key={status} value={status}>
//                                 {status}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                       </td>

//                       <td className="px-5 py-4">
//                         <div className="flex flex-col items-start gap-2">
//                           <StatusBadge
//                             status={room.housekeepingStatus || "clean"}
//                           />
//                           <select
//                             aria-label={`Change housekeeping for ${room.roomNumber}`}
//                             value={room.housekeepingStatus || "clean"}
//                             onChange={(event) =>
//                               handleHousekeepingChange(room, event.target.value)
//                             }
//                             className="max-w-40 rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs outline-none focus:border-indigo-500"
//                           >
//                             {["clean", "dirty", "cleaning", "inspected"].map(
//                               (status) => (
//                                 <option key={status} value={status}>
//                                   {status}
//                                 </option>
//                               )
//                             )}
//                           </select>
//                         </div>
//                       </td>

//                       <td className="px-5 py-4">
//                         <div className="flex justify-end gap-2">
//                           <button
//                             type="button"
//                             onClick={() => handleEdit(room)}
//                             className="rounded-lg border border-indigo-200 px-3 py-2 text-xs font-semibold text-indigo-700 transition hover:bg-indigo-50"
//                           >
//                             Edit
//                           </button>

//                           <button
//                             type="button"
//                             onClick={() => handleDelete(room)}
//                             className="rounded-lg border border-red-200 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-50"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </section>
//       </div>
//     </div>
//   );
// }




import React, { useEffect, useState } from "react";

const API =
  process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

const EMPTY_FORM = {
  roomCategoryId: "",
  roomNumber: "",
  floor: "",
  wing: "",
  notes: "",
};

async function apiRequest(url, options = {}) {
  const token = localStorage.getItem("vendorToken");

  const response = await fetch(`${API}${url}`, {
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(result.message || `Request failed (${response.status})`);
  }

  return result;
}

function getList(result, keys = []) {
  if (Array.isArray(result)) return result;

  for (const key of keys) {
    if (Array.isArray(result?.[key])) return result[key];
  }

  if (Array.isArray(result?.data)) return result.data;

  return [];
}

/* Resolve palace name from common property fields */
function getPalaceName(palace) {
  const possibleNames = [
    palace?.name,
    palace?.title,
    palace?.propertyName,
    palace?.palaceName,
    palace?.hotelName,
    palace?.basicInfo?.name,
    palace?.details?.name,
    palace?.property?.name,
  ];

  const name = possibleNames.find(
    (value) => typeof value === "string" && value.trim()
  );

  return name ? name.trim() : "";
}

function getCategoryId(room) {
  const category = room?.roomCategoryId || room?.roomCategory;

  return typeof category === "object"
    ? category?._id || ""
    : category || "";
}

function getCategoryName(room, categories) {
  const category = room?.roomCategoryId || room?.roomCategory;

  if (category && typeof category === "object") {
    return category.title || category.name || "—";
  }

  const found = categories.find((item) => item._id === category);

  return found?.title || found?.name || "—";
}

function StatCard({ title, value, icon }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-slate-500">{title}</p>
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-xl">
          {icon}
        </span>
      </div>

      <p className="mt-4 text-3xl font-bold text-slate-900">{value}</p>
    </div>
  );
}

function StatusBadge({ status }) {
  const value = String(status || "available").toLowerCase();

  const colors = {
    available: "bg-emerald-50 text-emerald-700",
    occupied: "bg-blue-50 text-blue-700",
    maintenance: "bg-amber-50 text-amber-700",
    blocked: "bg-red-50 text-red-700",
    clean: "bg-emerald-50 text-emerald-700",
    dirty: "bg-red-50 text-red-700",
    cleaning: "bg-amber-50 text-amber-700",
    inspected: "bg-indigo-50 text-indigo-700",
  };

  return (
    <span
      className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold capitalize ${
        colors[value] || "bg-slate-100 text-slate-600"
      }`}
    >
      {value.replaceAll("_", " ")}
    </span>
  );
}

export default function PalaceRoomUnits() {
  const [palaces, setPalaces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rooms, setRooms] = useState([]);

  const [palaceId, setPalaceId] = useState("");
  const [search, setSearch] = useState("");

  const [loadingPalaces, setLoadingPalaces] = useState(true);
  const [loadingRooms, setLoadingRooms] = useState(false);
  const [saving, setSaving] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    loadPalaces();
  }, []);

  useEffect(() => {
    if (palaceId) {
      loadRooms(palaceId);
    } else {
      setRooms([]);
      setCategories([]);
    }
  }, [palaceId]);

  async function loadPalaces() {
    setLoadingPalaces(true);
    setError("");

    try {
      const result = await apiRequest("/api/palaces");
      const list = getList(result, ["palaces", "properties", "results"]);

      setPalaces(list);

      if (list.length > 0) {
        setPalaceId((current) =>
          current && list.some((item) => item._id === current)
            ? current
            : list[0]._id
        );
      } else {
        setPalaceId("");
      }
    } catch (err) {
      setError(`Unable to load palaces: ${err.message}`);
    } finally {
      setLoadingPalaces(false);
    }
  }

  async function loadRooms(id = palaceId) {
    if (!id) return;

    setLoadingRooms(true);
    setError("");

    try {
      const [roomResult, categoryResult] = await Promise.all([
        apiRequest(`/api/palace-room-units/palace/${id}`),
        apiRequest(`/api/palace-room-categories/palace/${id}`),
      ]);

      setRooms(getList(roomResult, ["rooms", "roomUnits", "results"]));
      setCategories(
        getList(categoryResult, ["categories", "roomCategories", "results"])
      );
    } catch (err) {
      setError(`Unable to load room data: ${err.message}`);
    } finally {
      setLoadingRooms(false);
    }
  }

  function resetForm() {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setShowForm(false);
  }

  function openAddForm() {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setError("");
    setSuccess("");
    setShowForm(true);
  }

  function handleFieldChange(event) {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (!palaceId) {
      setError("Please select a palace first.");
      return;
    }

    if (!form.roomCategoryId || !form.roomNumber.trim()) {
      setError("Room Category and Room Number are required.");
      return;
    }

    setSaving(true);
    setError("");
    setSuccess("");

    const payload = {
      palaceId,
      roomCategoryId: form.roomCategoryId,
      roomNumber: form.roomNumber.trim(),
      floor: form.floor === "" ? "" : Number(form.floor),
      wing: form.wing.trim(),
      notes: form.notes.trim(),
    };

    try {
      const url = editingId
        ? `/api/palace-room-units/${editingId}`
        : "/api/palace-room-units";

      await apiRequest(url, {
        method: editingId ? "PUT" : "POST",
        body: JSON.stringify(payload),
      });

      setSuccess(
        editingId ? "Room updated successfully." : "Room added successfully."
      );

      resetForm();
      await loadRooms(palaceId);
    } catch (err) {
      setError(err.message || "Unable to save room.");
    } finally {
      setSaving(false);
    }
  }

  function handleEdit(room) {
    setForm({
      roomCategoryId: getCategoryId(room),
      roomNumber: room.roomNumber || "",
      floor: room.floor ?? "",
      wing: room.wing || "",
      notes: room.notes || "",
    });

    setEditingId(room._id);
    setShowForm(true);
    setError("");
    setSuccess("");

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  async function handleDelete(room) {
    if (
      !window.confirm(
        `Are you sure you want to delete room ${room.roomNumber}?`
      )
    ) {
      return;
    }

    setError("");
    setSuccess("");

    try {
      await apiRequest(`/api/palace-room-units/${room._id}`, {
        method: "DELETE",
      });

      setSuccess("Room deleted successfully.");
      await loadRooms(palaceId);
    } catch (err) {
      setError(err.message || "Unable to delete room.");
    }
  }

  async function handleStatusChange(room, status) {
    setError("");
    setSuccess("");

    try {
      await apiRequest(`/api/palace-room-units/${room._id}/status`, {
        method: "PATCH",
        body: JSON.stringify({ status }),
      });

      await loadRooms(palaceId);
      setSuccess("Room status updated.");
    } catch (err) {
      setError(err.message || "Unable to update room status.");
    }
  }

  async function handleHousekeepingChange(room, housekeepingStatus) {
    setError("");
    setSuccess("");

    try {
      await apiRequest(`/api/palace-room-units/${room._id}/housekeeping`, {
        method: "PATCH",
        body: JSON.stringify({ housekeepingStatus }),
      });

      await loadRooms(palaceId);
      setSuccess("Housekeeping status updated.");
    } catch (err) {
      setError(err.message || "Unable to update housekeeping.");
    }
  }

  const filteredRooms = rooms.filter((room) => {
    const categoryName = getCategoryName(room, categories);

    const searchableText = [
      room.roomNumber,
      room.floor,
      room.wing,
      categoryName,
      room.status,
      room.housekeepingStatus,
    ]
      .join(" ")
      .toLowerCase();

    return searchableText.includes(search.trim().toLowerCase());
  });

  const availableCount = rooms.filter(
    (room) => String(room.status || "available").toLowerCase() === "available"
  ).length;

  const occupiedCount = rooms.filter(
    (room) => String(room.status).toLowerCase() === "occupied"
  ).length;

  const maintenanceCount = rooms.filter(
    (room) => String(room.status).toLowerCase() === "maintenance"
  ).length;

  return (
    <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-[1500px] space-y-6">

        {/* Heading */}
        <header className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 sm:text-sm">
              Property Management
            </p>

            <h1 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              Palace Room Units
            </h1>

            <p className="mt-2 text-sm text-slate-500 sm:text-base">
              Manage room numbers, room status and housekeeping.
            </p>
          </div>

          {!showForm && (
            <button
              type="button"
              onClick={openAddForm}
              disabled={!palaceId}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-5 py-3 font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-200 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <span className="text-xl">+</span>
              Add Room
            </button>
          )}
        </header>

        {/* Messages */}
        {error && (
          <div
            role="alert"
            className="flex items-start justify-between gap-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
          >
            <span>{error}</span>
            <button type="button" onClick={() => setError("")}>
              ✕
            </button>
          </div>
        )}

        {success && (
          <div
            role="status"
            className="flex items-start justify-between gap-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700"
          >
            <span>{success}</span>
            <button type="button" onClick={() => setSuccess("")}>
              ✕
            </button>
          </div>
        )}

        {/* Palace selection */}
        <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
          <label
            htmlFor="palace-select"
            className="mb-2 block text-sm font-semibold text-slate-800"
          >
            Select Palace
          </label>

          <select
            id="palace-select"
            value={palaceId}
            onChange={(event) => {
              setPalaceId(event.target.value);
              resetForm();
              setError("");
              setSuccess("");
            }}
            disabled={loadingPalaces}
            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 sm:max-w-lg"
          >
            <option value="">
              {loadingPalaces ? "Loading palaces..." : "Select a palace"}
            </option>

            {palaces.map((palace) => (
              <option key={palace._id} value={palace._id}>
                {getPalaceName(palace) || `Palace (${palace._id})`}
              </option>
            ))}
          </select>

          {!loadingPalaces && palaces.length === 0 && (
            <p className="mt-3 text-sm text-amber-700">
              No palaces found. Check your vendor login and palace API.
            </p>
          )}
        </section>

        {/* Stats */}
        <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          <StatCard title="Total Rooms" value={rooms.length} icon="🏨" />
          <StatCard title="Available" value={availableCount} icon="✓" />
          <StatCard title="Occupied" value={occupiedCount} icon="🛏️" />
          <StatCard title="Maintenance" value={maintenanceCount} icon="🔧" />
        </section>

        {/* Form hidden until Add Room or Edit */}
        {showForm && (
          <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="flex flex-col justify-between gap-3 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:px-7">
              <div>
                <h2 className="text-xl font-bold text-slate-900">
                  {editingId ? "Edit Room" : "Add New Room"}
                </h2>

                <p className="mt-1 text-sm text-slate-500">
                  Enter the room details below.
                </p>
              </div>

              <button
                type="button"
                onClick={resetForm}
                className="self-start rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 sm:self-auto"
              >
                Close Form ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-5 sm:p-7">
              <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">

                {/* 1. Room Category */}
                <div>
                  <label
                    htmlFor="roomCategoryId"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Room Category <span className="text-red-500">*</span>
                  </label>

                  <select
                    id="roomCategoryId"
                    name="roomCategoryId"
                    value={form.roomCategoryId}
                    onChange={handleFieldChange}
                    required
                    className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                  >
                    <option value="">Select room category</option>

                    {categories.map((category) => (
                      <option key={category._id} value={category._id}>
                        {category.title || category.name || "Unnamed Category"}
                      </option>
                    ))}
                  </select>

                  {categories.length === 0 && (
                    <p className="mt-2 text-xs text-amber-700">
                      No categories found for this palace.
                    </p>
                  )}
                </div>

                {/* 2. Room Number */}
                <div>
                  <label
                    htmlFor="roomNumber"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Room Number <span className="text-red-500">*</span>
                  </label>

                  <input
                    id="roomNumber"
                    name="roomNumber"
                    value={form.roomNumber}
                    onChange={handleFieldChange}
                    required
                    placeholder="e.g. 101"
                    className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                  />
                </div>

                {/* 3. Floor */}
                <div>
                  <label
                    htmlFor="floor"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Floor
                  </label>

                  <input
                    id="floor"
                    name="floor"
                    type="number"
                    value={form.floor}
                    onChange={handleFieldChange}
                    placeholder="e.g. 1"
                    className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                  />
                </div>

                {/* 4. Wing */}
                <div>
                  <label
                    htmlFor="wing"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Wing
                  </label>

                  <input
                    id="wing"
                    name="wing"
                    value={form.wing}
                    onChange={handleFieldChange}
                    placeholder="e.g. East Wing"
                    className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                  />
                </div>

                {/* 5. Notes */}
                <div className="md:col-span-2">
                  <label
                    htmlFor="notes"
                    className="mb-2 block text-sm font-semibold text-slate-700"
                  >
                    Notes
                  </label>

                  <textarea
                    id="notes"
                    name="notes"
                    value={form.notes}
                    onChange={handleFieldChange}
                    rows={3}
                    placeholder="Add optional room notes..."
                    className="w-full resize-y rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100"
                  />
                </div>
              </div>

              <div className="mt-7 flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">
                <button
                  type="button"
                  onClick={resetForm}
                  className="rounded-xl border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={saving || categories.length === 0}
                  className="rounded-xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-200 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {saving
                    ? "Saving..."
                    : editingId
                    ? "Update Room"
                    : "Save Room"}
                </button>
              </div>
            </form>
          </section>
        )}

        {/* Rooms table */}
        <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col justify-between gap-4 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:p-6">
            <div>
              <h2 className="text-lg font-bold text-slate-900">All Rooms</h2>

              <p className="mt-1 text-sm text-slate-500">
                {filteredRooms.length} room
                {filteredRooms.length !== 1 ? "s" : ""} found
              </p>
            </div>

            <input
              type="search"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search rooms..."
              className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 sm:max-w-sm"
            />
          </div>

          {!palaceId ? (
            <div className="p-10 text-center text-sm text-slate-500">
              Select a palace to view its rooms.
            </div>
          ) : loadingRooms ? (
            <div className="p-12 text-center text-sm text-slate-500">
              Loading rooms...
            </div>
          ) : filteredRooms.length === 0 ? (
            <div className="px-5 py-14 text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-2xl">
                🏨
              </div>

              <h3 className="mt-4 font-bold text-slate-900">No rooms found</h3>

              <p className="mt-1 text-sm text-slate-500">
                {search
                  ? "Try another search term."
                  : "Add your first room using the Add Room button."}
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[1050px] text-left text-sm">
                <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
                  <tr>
                    <th className="px-5 py-4 font-semibold">Room Number</th>
                    <th className="px-5 py-4 font-semibold">Category</th>
                    <th className="px-5 py-4 font-semibold">Floor / Wing</th>
                    <th className="px-5 py-4 font-semibold">Room Status</th>
                    <th className="px-5 py-4 font-semibold">Housekeeping</th>
                    <th className="px-5 py-4 text-right font-semibold">Actions</th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-100">
                  {filteredRooms.map((room) => (
                    <tr
                      key={room._id}
                      className="transition hover:bg-slate-50"
                    >
                      <td className="px-5 py-4 font-bold text-slate-900">
                        {room.roomNumber || "—"}
                      </td>

                      <td className="px-5 py-4 text-slate-600">
                        {getCategoryName(room, categories)}
                      </td>

                      <td className="px-5 py-4 text-slate-600">
                        {room.floor ?? "—"} / {room.wing || "—"}
                      </td>

                      <td className="px-5 py-4">
                        <div className="flex flex-col items-start gap-2">
                          <StatusBadge status={room.status} />

                          <select
                            aria-label={`Room status ${room.roomNumber}`}
                            value={room.status || "available"}
                            onChange={(event) =>
                              handleStatusChange(room, event.target.value)
                            }
                            className="rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs outline-none focus:border-indigo-500"
                          >
                            {[
                              "available",
                              "occupied",
                              "maintenance",
                              "blocked",
                            ].map((status) => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>

                      <td className="px-5 py-4">
                        <div className="flex flex-col items-start gap-2">
                          <StatusBadge
                            status={room.housekeepingStatus || "clean"}
                          />

                          <select
                            aria-label={`Housekeeping ${room.roomNumber}`}
                            value={room.housekeepingStatus || "clean"}
                            onChange={(event) =>
                              handleHousekeepingChange(room, event.target.value)
                            }
                            className="rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs outline-none focus:border-indigo-500"
                          >
                            {["clean", "dirty", "cleaning", "inspected"].map(
                              (status) => (
                                <option key={status} value={status}>
                                  {status}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </td>

                      <td className="px-5 py-4">
                        <div className="flex justify-end gap-2">
                          <button
                            type="button"
                            onClick={() => handleEdit(room)}
                            className="rounded-lg border border-indigo-200 px-3 py-2 text-xs font-semibold text-indigo-700 transition hover:bg-indigo-50"
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(room)}
                            className="rounded-lg border border-red-200 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-50"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
